import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import apiUrlPoint from '../../life-config/apiEndPoints.json';
import lifeProductType from '../../life-config/productCodeConfig.json';
import TataProposal from '../../life-config/proposalConfig/tataProposalConfig.json';
import { ApiService } from '../../services/api.service';
import { CommonModalService } from '../../services/common-modal.service';
import { DialogData } from '../../model/data.model';
import { SharedApiService } from '../../services/shared-api.service';
import lifeProposalJson from '../../life-config/lifeQuotesConfig.json';
import {  SharedDataService} from '../../services/shared-data.service';

@Component({
    selector: 'app-plan-details',
    templateUrl: './plan-details.component.html',
    styleUrls: ['./plan-details.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class PlanDetailsComponent implements OnInit {

    productType: object = lifeProductType.product_type;
    tataProposalInfo: any = TataProposal.TataProposalFormInitialJson;
    editProposalModalJson: any = lifeProposalJson.editModalInitialJson;
    apiUrl: object = apiUrlPoint.apiEndPoints;
    proposalCompTransferVal: any;
    uuid: string;
    proposalId: string;
    proposalInitalResponse: any;
    proposalRes: any;
    coverageAgeNo: number | string;
    grossPremium: number | string;
    sumAssured: number | string;
    basePremium: number | string;
    tax: number | string;
    uiDobVal: any;
    optedRiderVal: any;
    yearsToDisplay: any;
    isCoverageAgeError: any;
    payTillAge: any;
    limitedPayList: any;
    dob:any;
    annualIncome: any;
    savingFrequencyList: any;
    paymentFrequency: any;
    maturityBenefit: any;
    deathBenefit: any;
    frequencyType: string;
    constructor(private apiService: ApiService,
        private activatedRoute: ActivatedRoute,
        private commonModal: CommonModalService,
        private sharedData: SharedApiService,
        private datePipe: DatePipe,
        private sharedDataService : SharedDataService

    ) {

        this.sharedData.invokeEvent.subscribe(value => {
            if (value) {

                this.feedOnLimitedPay(value);

                this.proposalRes = value;
                if (value && value['opted_rider'] && value['opted_rider'].length > 0 ){

                    this.optedRiderVal =   value['opted_rider'];
                } else {
                    this.optedRiderVal =  value['riders']
                }




            }
        });



        this.sharedDataService.getRecalculatePremium.subscribe(value => {
            if (value) {

                if (value['death_benefits']){

                    this.deathBenefit = value['death_benefits'];
                }

                if (value['maturity_benefits']){

                    this.maturityBenefit = value['maturity_benefits'];
                }
                this.feedOnLimitedPay(value);


                this.optedRiderVal = value['riders'];


            }
        });

        /**
         * this is complete proposla event
         * change it after
         */
        this.sharedData.invokeDobEvent.subscribe(value => {
            if (value) {
                this.feedDobData(value);

            }
        });

        /**
         * this dob data will be shared only it has been changed from user
         * Without unsuccessful waiting of respose
         * As BE required dob value to validate for coverage age
         */


        this.sharedData.invokeUIDob.subscribe(value => {
            if (value) {

                this.uiDobVal = value;

            }
        });




    }


    // get Proposal Form
    feedProposalData() {

        this.basePremium = this.proposalRes['base_premium'];
        this.grossPremium = this.proposalRes['gross_premium'];
        this.tax = this.proposalRes['total_tax'];
        this.sumAssured = this.proposalRes['sum_assured'];
        if (this.proposalRes['death_benefits']){

            this.deathBenefit = this.proposalRes['death_benefits'];
        }

        if (this.proposalRes['maturity_benefits']){

            this.maturityBenefit = this.proposalRes['maturity_benefits'];
        }
        this.annualIncome = this.proposalRes['lifeassured']['annual_income'] ;
        this.savingFrequencyList = this.proposalRes['available_premium_instalment_type'];
        this.dob = this.datePipe.transform(new Date(this.proposalRes['lifeassured']['dob']), 'dd-MM-yyyy'),
        this.savingFrequencyList.forEach(element => {

            if (this.proposalRes['premium_installment_type'] === element['value']){
                this.frequencyType = element['ui_name'];
                this.paymentFrequency = element['name'];

            }
        });

        /**
         * pay till age / Riders if available
         */


         if (this.proposalRes['product_type'] == this.productType['termProductType']){

            this.setPayTillAge();
         }

        if (this.proposalRes['opted_rider'] &&  this.proposalRes['opted_rider'].length > 0) {


            this.optedRiderVal = this.proposalRes['opted_rider'];

        }


        if (this.proposalRes['whole_life_opted']) {

            this.coverageAgeNo = this.tataProposalInfo['whole-life'];
            this.yearsToDisplay = false;

        } else {

            this.coverageAgeNo = this.proposalRes['coverage_age'];
            if (typeof this.coverageAgeNo === 'number') {
                this.yearsToDisplay = true;
            }
        }


        // const ageObtained = this.sharedData.getAgeInyears(new Date( this.proposalRes ['lifeassured']['dob']));
        // this.coverageAgeNo = ageObtained + this.proposalRes['policy_term'];


    }

    setPayTillAge() {



        if (this.proposalRes['available_plans_set']) {

            this.limitedPayList = this.proposalRes['available_plans_set'];

        } else {
            this.limitedPayList = this.editProposalModalJson['payTillAge']['limitedPayList'];
        }

        this.limitedPayList.forEach((element) => {



            if (element['premiumPaymentType'] === this.proposalRes['premium_payment_type']) {

                /**
                  * ToDos
                */

                if (this.proposalRes['premium_payment_type'] === 2) {

                    this.payTillAge = element['name']

                }

                if (this.proposalRes['premium_payment_type'] === 4) {

                    this.payTillAge = element['name']

                }


                /**
                 * Check for regular case as premum payment type is same for 5, 7, 10
                 */
                if (this.proposalRes['premium_term'] === element['value']) {

                    this.payTillAge = element['name']
                }

                if (this.proposalRes['premium_payment_type'] === 4) {

                    this.payTillAge = element['name']

                }


                /**
                 * Check for regular case as premum payment type is same for 5, 7, 10
                 */
                if (this.proposalRes['premium_term'] === element['value']) {

                    this.payTillAge = element['name']
                }


            }



        });



    }

    /**
     * updating value on limited pay
     */

    feedOnLimitedPay(value) {
        if (value) {

            this.basePremium = value['base_premium'];
            this.grossPremium = value['gross_premium'];
            this.tax = value['total_tax'];

            if (this.proposalRes['opted_rider'].length > 0) {


                this.optedRiderVal = this.proposalRes['opted_rider'];

            }
        }



    }

    feedDobData(cmpPropRes) {
        /**
         * Feeding entire response
         * As modal will get value from here
         */
        this.proposalRes = cmpPropRes['response'];


        /**
         * conditon to check whhether it is whole life or not
         */
        if (this.proposalRes['coverage_age'] && !this.proposalRes['whole_life_opted']) {

            this.coverageAgeNo = this.proposalRes['coverage_age'];

            if (typeof this.coverageAgeNo === 'number') {

                this.yearsToDisplay = true;
            }
        } else {
            this.coverageAgeNo = 'Whole life';

            if (typeof this.coverageAgeNo === 'string') {

                this.yearsToDisplay = false;
            }
        }
    }

    // Open Dialog Box

    openDialog(modalType: number, widthObtained: string, heightObtained: string, topObtained: string, classObtained: string, event) {

        let resWidth;
        if (window.screen.width <= 767) {
            resWidth = '95%';
            heightObtained = '530px';
            topObtained = '2%';
        } else {
            resWidth = widthObtained;
        }

        let xplacement = event.clientX;
        xplacement = (event.clientX - 190);

        const obj: DialogData = {
            type: modalType,
            width: widthObtained,
            height: heightObtained,
            classNameObtained: classObtained,
            minWidth: resWidth,
            dataInfo: {
                uuid: this.uuid,
                proposalId: this.proposalId,
                top: topObtained,
                editProposalModal: this.proposalRes, onUIChange: this.uiDobVal,
            },

        };

        // When modal dialog box closed -so data retreival and opening off dialog box

        this.commonModal.openDialog(obj).subscribe(data => {

            if (data !== undefined) {

                if (data['data']['proposalResponse']) {

                    this.proposalRes = data['data']['proposalResponse'];
                    this.sharedData.callMethodForProposalComponent( this.proposalRes);
                    this.annualIncome = this.proposalRes['lifeassured']['annual_income'] ;
                    this.dob = this.datePipe.transform(new Date(this.proposalRes['lifeassured']['dob']), 'dd-MM-yyyy'),
                    this.savingFrequencyList =  this.proposalRes['available_premium_instalment_type'];
                    if (data['data'] && data['data']['updatedPremiumOnRecal'] && data['data']['updatedPremiumOnRecal']['death_benefits']){

                        this.deathBenefit = data['data']['updatedPremiumOnRecal']['death_benefits'];
                    }

                    if (data['data'] && data['data']['updatedPremiumOnRecal'] && data['data']['updatedPremiumOnRecal']['maturity_benefits']){

                        this.maturityBenefit = data['data']['updatedPremiumOnRecal']['maturity_benefits'];
                    }
                    this.savingFrequencyList.forEach(element => {

                        if (this.proposalRes['premium_installment_type'] === element['value']){

                            this.paymentFrequency = element['name'];
                            this.frequencyType = element['ui_name'];

                        }
                    });
                    if (this.proposalRes['product_type'] == this.productType['termProductType']){

                        this.setPayTillAge();
                    }

                    if ( this.proposalRes && this.proposalRes['opted_rider'] && this.proposalRes['opted_rider'].length > 0) {


                        this.optedRiderVal = this.proposalRes['opted_rider'];

                    } else {
                        this.optedRiderVal = [];
                    }
                    /**
                     * Sending updated proposal response to limited plan
                     * So be will get coverage age
                     */


                    this.sharedData.callMethodForProposalComponent(this.proposalRes);

                    /**
                     * Assigning back to respective variable as  recaluclate premium rsponse  object  structure i different
                     * it will diffcult the conditonn
                     */

                    this.basePremium = this.proposalRes['base_premium'];
                    this.grossPremium = this.proposalRes['gross_premium'];
                    this.tax = this.proposalRes['total_tax'];
                    this.sumAssured = this.proposalRes['sum_assured'];
                    /**
                     * conditon to check whhether it is whole life or not
                     */
                    if (this.proposalRes['coverage_age'] && !this.proposalRes['whole_life_opted']) {

                        this.coverageAgeNo = this.proposalRes['coverage_age'];
                        if (typeof this.coverageAgeNo === 'number') {

                            this.yearsToDisplay = true;
                        }

                    } else {
                        this.coverageAgeNo = 'Whole life';

                        if (typeof this.coverageAgeNo === 'string') {

                            this.yearsToDisplay = false;
                        }
                    }


                    /**
                     * show coveerage age up to
                   */

                    const ageObtained = this.sharedData.getAgeInyears(new Date(this.proposalRes['lifeassured']['dob']));
                    // this.coverageAgeNo = ageObtained + this.proposalRes['policy_term'];
                }

                if (data['data']['updatedPremiumOnRecal']) {

                    this.basePremium = data['data']['updatedPremiumOnRecal']['base_premium'];
                    this.grossPremium = data['data']['updatedPremiumOnRecal']['gross_premium'];
                    this.tax = data['data']['updatedPremiumOnRecal']['total_tax'];
                    this.sumAssured = data['data']['updatedPremiumOnRecal']['sum_assured'];
                    this.optedRiderVal = data['data']['updatedPremiumOnRecal']['riders'];

                }



                /**
                 * Invoking BI as per Business/ Product call
                 * And QA BUG - T6942
                 */


                this.sharedData.getBenefitIllustration(this.proposalId, this.uuid).subscribe(res => {
                    if (res) {

                        this.sharedData.callMethodForBIComponent(res);

                    }

                });


            }


        });
    }


    // minimize this function by pass parms #TODOs

    openPremiumBreakUp(modalType: number, widthObtained: string, heightObtained: string, topObtained: string, classObtained: string, event) {


        let resWidth;
        if (window.screen.width <= 767) {
            resWidth = widthObtained;
        } else {
            resWidth = '29%';
        }
        let xplacement = event.clientX;
        xplacement = (event.clientX - 190);

        const dataSetOnRecalculate = {
            base_premium: this.basePremium,
            gross_premium: this.grossPremium,
            tax: this.tax
        };

        const obj: DialogData = {
            type: modalType,
            width: widthObtained,
            height: heightObtained,
            minWidth: resWidth,
            classNameObtained: classObtained,
            dataInfo: {
                uuid: this.uuid,
                proposalId: this.proposalId,
                editProposalModal: dataSetOnRecalculate,
                proposalInfo:this.proposalRes,
                top: topObtained,
                left: (xplacement) + 'px',
                optedRider: this.optedRiderVal
            },

        };

        this.commonModal.openDialog(obj).subscribe(data => {
            if (data !== undefined) {

                const dataInfo = data['data']['response'];
            }

            // Display of limited pay
            // Recalculate Premium
            // if (this.proposalRes) {
            //     this.initiateRecalculatePremium();
            // }
        });

    }

    ngOnInit() {

        this.activatedRoute.params.subscribe(params => {

            this.proposalId = params['proposalId'];
            this.uuid = params['uuid'];

        });

        if (this.proposalId && this.uuid) {

            /**
             * Invoking from single services
             */
            this.sharedData.getProposalInfo(this.proposalId, this.uuid).subscribe(res => {
                if (res) {

                    this.proposalRes = res;
                    if (this.proposalRes) {

                        this.feedProposalData();
                    }
                }

            });

        }


    }

}









